<template>
  <div>
    <div id="main" style="width:378px;height:378px;margin-left:12px"></div>
  </div>
</template>

<script>

  export default {
    name: "k-line",
    data() {
      return {
        arr: [],
        props: ['option'],
        option1: {
          xAxis: {
            type: 'category',
            data: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']
          },
          yAxis: {
            type: 'value'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          series: [{
            //data: [3320, 3332, 3391, 3334, 33290, 33330, 3520,3560, 3572, 3591, 3634, 3690, 3130, 3120,3310, 3532, 3691, 3634, 3290, 3730, 3320,3920, 3632, 3891],
            data: [1023, 3233, 2422, 6012, 3290, 3521, 3967, 3631, 3234, 3167, 2583, 2822, 2931, 5463, 1759, 3637, 2615, 2736, 3315, 3291, 2534, 2479, 2333, 1215],
            type: 'line'
          }]
        },


      }
    },
    mounted() {


      // console.log(this.option);
      // console.log(this.option1);
      // // 绘制图表。
      echarts.init(document.getElementById('main')).setOption(this.option1);
      //这是1到11的


    },


  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/kLine.vue